import React from "react";
import "./ResearchPapers.css";

const papers = [
  {
    title:
      "A Transfer Learning Approach for Skin Cancer Classification Using Dense CNN Optimized with Radam and CosineAnnealing",
    journal:
      "3rd DMIHER International Conference on Artificial Intelligence",
    year: "2025",
    scholar:
      "https://scholar.google.com/citations?hl=en&user=mNlOTfUAAAAJ&scilu=&scisig=AKLELW8AAAAAanCWYIMXZVW4RwkDOw4ES5RYEZ4",
  },

  {
    title:
      "Efficient State-of-Health Prediction of Lithium-Ion Batteries Using a Hybrid Metaheuristic-Optimized Deep Network Model",
    journal:
      "2026 International Conference on Electrical and Electronics for Sustainable Energy",
    year: "2026",
    scholar:
      "https://scholar.google.com/citations?hl=en&user=mNlOTfUAAAAJ&scilu=&scisig=AKLELW8AAAAAanCWYIMXZVW4RwkDOw4ES5RYEZ4",
  },

  {
    title:
      "A Comprehensive Multi-Model Framework for Lung Cancer Image Classification Integrating Advanced Deep Learning and Explainable AI",
    journal:
      "6th International Conference on Electronics, Materials Engineering & Nano-Technology",
    year: "2026",
    scholar:
      "https://scholar.google.com/citations?hl=en&user=mNlOTfUAAAAJ&scilu=&scisig=AKLELW8AAAAAanCWYIMXZVW4RwkDOw4ES5RYEZ4",
  },

  {
    title:
      "A Compact Envelope-Type Module for Asymmetric Multilevel Inverter with Reduced Components and PSO-Based Selective Harmonic Elimination",
    journal:
      "International Conference on Innovation in Energy Management and Renewable Energy",
    year: "2025",
    scholar:
      "https://scholar.google.com/citations?hl=en&user=mNlOTfUAAAAJ&scilu=&scisig=AKLELW8AAAAAanCWYIMXZVW4RwkDOw4ES5RYEZ4",
  },

  {
    title:
      "TriFuse-Net: A Causal-Convolutional Residual Bidirectional GRU with Multi-Head Self-Attention and UJ-Swarm-Optimized UMAP-Fused Transfer Learning for Lithium-Ion Battery State-of-Health Prediction",
    journal: "SSRN Preprint",
    year: "2026",
    scholar:
      "https://scholar.google.com/citations?hl=en&user=mNlOTfUAAAAJ&scilu=&scisig=AKLELW8AAAAAanCWYIMXZVW4RwkDOw4ES5RYEZ4",
  },
];
const ResearchPapers = () => {
  return (
    <section className="research-section" id="research">
      <div className="research-container">
        <h2 className="research-title">
          📑 Latest Research Papers
        </h2>

        <div className="research-grid">
          {papers.map((paper, index) => (
            <div className="paper-card" key={index}>
              <div className="glow"></div>

              <h3>{paper.title}</h3>

              <p className="journal">
                {paper.journal} • {paper.year}
              </p>

              <a
                href={paper.scholar}
                target="_blank"
                rel="noreferrer"
                className="scholar-btn"
              >
                🔍 View on Google Scholar
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResearchPapers;